import { MENU_ROUTE_ID } from './common';
import MenuManagement from './components/MenuManagement';

export default {
    [MENU_ROUTE_ID]: () => <MenuManagement />
};
